var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgCreditCard = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18.905,
    height: 14.704,
    viewBox: "0 0 18.905 14.704",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "credit-card-regular",
    d: "M5.514,41.977a.788.788,0,1,1,0,1.575H3.939a.788.788,0,1,1,0-1.575Zm6.3,0a.788.788,0,1,1,0,1.575H8.14a.788.788,0,1,1,0-1.575ZM16.8,32a2.1,2.1,0,0,1,2.1,2.1V44.6a2.1,2.1,0,0,1-2.1,2.1H2.1A2.1,2.1,0,0,1,0,44.6V34.1A2.1,2.1,0,0,1,2.1,32Zm0,1.575H2.1a.525.525,0,0,0-.525.525v1.05H17.33V34.1A.526.526,0,0,0,16.8,33.575ZM17.33,38.3H1.575v6.3a.526.526,0,0,0,.525.525H16.8a.527.527,0,0,0,.525-.525Z",
    transform: "translate(0 -32)",
    fill: "#ffce05"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgCreditCard);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/credit-card.5f74cd5042b05254591f7b648b6f8c7f.svg";